import { doc, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from './firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import './game.css';

function Home() {
    const navigate = useNavigate();
    const [isHomeOn, setIsHomeOn] = useState(false);

    useEffect(() => {

        const unsub = onSnapshot(doc(db, "home", "FkAGT2s9xDP9rsEY6PSw"), (doc) => {
    
          const data = doc.data();
    
          setIsHomeOn(Boolean(data?.isOn))
    
        });
    
        return () => unsub();
    
      }, []);

      

  return (
    <div className="game-shell">
        <div className="game-stage player-landing-stage">
          <div className="player-landing-panel">
            <div className="party-sign">
              <span>Desi</span>
              <strong>50+</strong>
            </div>
            <div className="player-landing-copy">
              <p className="game-kicker">{isHomeOn ? "Live now" : "Desi Couples Trivia Night"}</p>
              <h1 className="game-title">Good Times, Great Company</h1>
              <p className="game-subtitle">Enter your name and join the get-together trivia, full of nostalgia, smiles, and friendly bragging rights.</p>
              <Button
                className="party-primary-button"
                size="large"
                variant="contained"
                onClick={() => { navigate("/start") }}
                to="/start"
              >
                Join the Party
              </Button>
            </div>
            <div className="party-ticket" aria-hidden="true">
              <div className="party-ticket-top">Tonight's Mehfil</div>
              <div className="party-ticket-main">Trivia</div>
              <div className="party-lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Home

